import React, { FunctionComponent } from 'react';

import { $ButtonGroup } from './ButtonGroup.styles';

interface ButtonGroupProps {
  isFluid?: boolean;
  withMargin?: boolean;
  dataTestId?: string;
  shouldBeAlwaysHorizontal?: boolean;
}

const ButtonGroup: FunctionComponent<
  React.PropsWithChildren<ButtonGroupProps>
> = ({
  children,
  isFluid = false,
  withMargin = true,
  dataTestId,
  shouldBeAlwaysHorizontal = false,
}) => {
  return (
    <$ButtonGroup
      $isFluid={isFluid}
      $withMargin={withMargin}
      data-testid={dataTestId}
      $shouldBeAlwaysHorizontal={shouldBeAlwaysHorizontal}
    >
      {children}
    </$ButtonGroup>
  );
};

export default ButtonGroup;
